import "@hotwired/turbo-rails"
import { mountIslands, unmountIslands } from "./islands/mount"
import { startWeather, stopWeather } from "./hero/weather"
import { startNav, stopNav } from "./nav"
import { startChapters, stopChapters } from "./chapters"

document.addEventListener("turbo:load", () => {
  mountIslands()
  startWeather()
  startNav()
  startChapters()
})

document.addEventListener("turbo:before-cache", () => {
  unmountIslands()
  stopWeather()
  stopNav()
  stopChapters()
})
